import React from "react";
import PropTypes from "prop-types";
import { Box, InputAdornment } from "@mui/material";

import UISelect from "../UISelect";
import UICountryFlag from "../UICountryFlag";
import "./UISelectCountry.scss";

const getCountryOptionLabel = (option) => {
  if (!option) return "";
  if (typeof option === "string") return option;
  return option.name || "";
};

const UISelectCountry = ({
  options,
  value,
  onChange,
  textFieldProps,
  filterOptions,
  ...props
}) => {
  const selectedFlag = value?.flag || value?.shortCode;

  return (
    <UISelect
      {...props}
      options={options}
      value={value}
      onChange={onChange}
      getOptionLabel={getCountryOptionLabel}
      isOptionEqualToValue={(option, selected) =>
        String(option?.id) === String(selected?.id)
      }
      filterOptions={filterOptions}
      renderOption={(renderProps, option) => (
        <Box
          component="li"
          {...renderProps}
          key={option.id}
          className={`${renderProps.className || ""} ui-select-country__option`}
        >
          <UICountryFlag flag={option.flag} shortCode={option.shortCode} />
          <Box component="span" className="ui-select-country__name">
            {option.name}
          </Box>
        </Box>
      )}
      textFieldProps={{
        ...textFieldProps,
        InputProps: {
          ...textFieldProps?.InputProps,
          startAdornment: selectedFlag ? (
            <InputAdornment position="start">
              <UICountryFlag flag={value?.flag} shortCode={value?.shortCode} />
            </InputAdornment>
          ) : (
            textFieldProps?.InputProps?.startAdornment
          ),
        },
      }}
    />
  );
};

UISelectCountry.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.object,
  onChange: PropTypes.func,
  textFieldProps: PropTypes.object,
  filterOptions: PropTypes.func,
};

UISelectCountry.defaultProps = {
  options: [],
  value: null,
  onChange: undefined,
  textFieldProps: {},
  filterOptions: undefined,
};

export default UISelectCountry;
